import { api } from '../api';

export interface BgtUserDto {
  id: string;
  name: string | null;
  patientCode: string | null;
  birthDate: string | null;
  age: number | null;
  alreadyMapped: boolean;
}

export interface PaginatedBgtUsers {
  items: BgtUserDto[];
  total: number;
  page: number;
  limit: number;
}

export interface ListBgtUsersQuery {
  page?: number;
  limit?: number;
  search?: string;
  unmappedOnly?: boolean;
}

export async function listBgtUsers(query: ListBgtUsersQuery): Promise<PaginatedBgtUsers> {
  const res = await api.get<PaginatedBgtUsers>('/bgt-users', { params: query });
  return res.data;
}
